import { useMyProfile } from "./useMyProfile";
import ProfileQueryState from "./components/ProfileQueryState";
import ProfileHeader from "./components/ProfileHeader";
import ProfileTabs from "./components/ProfileTabs";
import MyApproversCard from "./components/MyApproversCard";
import ui from "../../components/ui/ui.module.css";
import styles from "./Profile.module.css";

// Read-only view of the logged-in employee's record (GET /employee/me).
const MyProfileView = () => {
  const profileQuery = useMyProfile();

  return (
    <div className={`${ui.page} ${styles.page}`}>
      <div className={ui.pageHeader}>
        <div>
          <h4 className="page-title">My Profile</h4>
          <p className="page-subtitle">
            <i className="bi bi-info-circle me-1"></i>
            To correct your information, contact HR.
          </p>
        </div>
      </div>

      <ProfileQueryState query={profileQuery}>
        {(record) => (
          <>
            <ProfileHeader
              profile={record.profile}
              photoUrl={record.photoUrl}
            />
            <MyApproversCard />
            <div className={ui.card}>
              <ProfileTabs record={record} />
            </div>
          </>
        )}
      </ProfileQueryState>
    </div>
  );
};

export default MyProfileView;
